import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=73370fdc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=73370fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73370fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73370fdc')) {
      api.createRecord('73370fdc', component.options)
    } else {
      api.reload('73370fdc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=73370fdc&scoped=true&", function () {
      api.rerender('73370fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uL3rAjmWEnP2/JS/comp/GuestBox.vue"
export default component.exports